import React, { FC, RefObject, useEffect, useRef, useState } from 'react';
import NukaSwiper, {
    CarouselControlContainerProp,
    CarouselProps,
} from 'nuka-carousel';

import { ICustomDotsStyles } from './DefaultDots/styled';
import DefaultArrow, { IArrowProps } from './DefaultArrow';
import DefaultDots, { IDotsProps } from './DefaultDots';

import * as ST from './styled';

export interface ICarouselProps extends CarouselProps {
    withoutArrows?: boolean,
    withoutDots?: boolean,
    customArrow?: FC<IArrowProps>,
    customDots?: FC<IDotsProps>,
    customDotsStyles?: ICustomDotsStyles,
}

interface INukaSwiperMethods {
    setDimensions: () => void,
}

const DEFAULT_AUTOPLAY_INTERVAL = 3000;
const DOTS_PADDING = -20;
const ARROWS_PADDING = -32;

const getDefaultControlsContainerStyles = (key: CarouselControlContainerProp) => {
    switch (key) {
        case 'BottomCenter':
            return {
                bottom: DOTS_PADDING,
            };
        case 'CenterRight':
            return {
                right: `${ARROWS_PADDING}px`,
            };
        case 'CenterLeft':
            return {
                left: `${ARROWS_PADDING}px`,
            };
        default: return;
    }
};

const NukaCarousel: FC<ICarouselProps> = ({
    customArrow: CustomArrow,
    customDots: CustomDots,
    children,
    withoutArrows,
    withoutControls,
    withoutDots,
    autoplayInterval = DEFAULT_AUTOPLAY_INTERVAL,
    autoplay,
    className,
    customDotsStyles,
    ...props
}) => {
    const [pausedAutoplay, setPausedAutoplay] = useState(false);
    const Arrow = CustomArrow || DefaultArrow;
    const Dots = CustomDots || DefaultDots;
    const swiperRef = useRef<NukaSwiper & INukaSwiperMethods>();

    useEffect(() => {
        swiperRef?.current?.setDimensions();
    }, [withoutArrows, withoutControls]);

    const handleMouseOver = () => {
        if (autoplay) {
            setPausedAutoplay(true);
        }
    };

    const handleMouseOut = () => {
        if (autoplay) {
            setPausedAutoplay(false);
        }
    };

    return (
        <ST.Container
            withoutDots={withoutDots || withoutControls}
            withoutArrows={withoutArrows || withoutControls}
            onTouchStart={handleMouseOver}
            onTouchEnd={handleMouseOut}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
            className={className}
        >
            <NukaSwiper
                ref={swiperRef as RefObject<any>}
                // @ts-ignore
                getControlsContainerStyles={getDefaultControlsContainerStyles}
                renderCenterLeftControls={({ previousSlide }) => withoutArrows || <Arrow previousSlide={previousSlide} />}
                renderCenterRightControls={({ nextSlide }) => withoutArrows || <Arrow nextSlide={nextSlide} /> }
                renderBottomCenterControls={(props) => withoutDots || (
                        <Dots
                            {...props}
                            autoplayInterval={autoplayInterval}
                            autoplay={!!(autoplay && !pausedAutoplay)}
                            customDotsStyles={customDotsStyles}
                        />
                    )}
                autoplayInterval={autoplayInterval}
                autoplay={autoplay}
                withoutControls={withoutControls}
                {...props}
            >
                {children}
            </NukaSwiper>
        </ST.Container>
    );
};

export default NukaCarousel;
